<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18">
    <path
      d="M9.863 1.734 3.699 7.92 22 7.998l-.039 1.828-18.339.039 6.203 6.224-1.31 1.323L0 8.931 8.553.412z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
